import React from "react";
import { Grid, makeStyles, useTheme } from "@material-ui/core";
import { labels } from "../shared/translations";

import {
  Container,
  TextField,
  Typography,
  Button,
  Paper,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
  },
  form: {
    marginTop: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(3),
  },

  root: {
    display: "flex",
    position: "relative",
    height: 300,
    width: "80%",
    overflow: "hidden",
  },
  rootLeft: {
    display: "flex",
    position: "relative",
    height: 400,
    width: "80%",
    overflow: "hidden",
  },
  details: {
    display: "flex",
    flexDirection: "row",
    flex: 1,
    padding: theme.spacing(2),
    zIndex: 1,
  },
  content: {
    flex: "1 0 auto",
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingTop: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  right: {
    position: "relative",
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  circleBackground: {
    position: "absolute",
    width: 600,
    height: 600,
    backgroundColor: "#31ccad5b",
    borderRadius: "50%",
    right: "-60px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 0,
  },
  circleBackgroundLeft: {
    position: "absolute",
    width: 600,
    height: 600,
    backgroundColor: "#31ccad5b",
    borderRadius: "50%",
    left: "-150px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 0,
  },
  cover: {
    width: 100,
    height: 100,
    borderRadius: "5%",
    objectFit: "cover",
    zIndex: 1,
  },
}));

export const RegistrationPage = ({
  setPrivacyPolicy,
  privacyPolicy,
  formData,
  setFormData,
  createProfessional,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Dati inviati:", formData);
    // Puoi aggiungere chiamata API qui
  };

  return (
    <Container maxWidth="sm">
      <Paper className={classes.paper} elevation={3}>
        <Typography variant="h5" align="center" gutterBottom>
          Registrazione Utente
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Nome e Cognome */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Nome"
                name="name"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Cognome"
                name="surname"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>

            {/* Email e Password */}
            <Grid item xs={12}>
              <TextField
                label="Email"
                name="email"
                type="email"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Password"
                name="password"
                type="password"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>

            {/* Dati di Fatturazione */}
            <Grid item xs={12}>
              <Typography variant="subtitle1">
                Dati per la fatturazione
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.business_name}
                name="ragionesociale"
                type="text"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.address}
                name="address"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.city}
                name="city"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.cap}
                name="cap"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.nation}
                name="paese"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.piva}
                name="piva"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label={labels.account.accountForm.fiscalCode}
                name="fiscalcode"
                fullWidth
                variant="outlined"
                onChange={handleChange}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <div>
                <input
                  type="checkbox"
                  id="privacyPolicy"
                  name="privacyPolicy"
                  checked={privacyPolicy}
                  onChange={() => {
                    setPrivacyPolicy(!privacyPolicy);
                  }}
                />
                <label htmlFor="privacyPolicy" style={{ color: "black" }}>
                  Accept the{" "}
                  <a
                    style={{ color: "blue" }}
                    href="https://mypowerset.com/privacy-policy/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                </label>
              </div>
            </Grid>
            {/* Submit */}
            <Grid item xs={12}>
              <Button
                type="submit"
                fullWidth
                onClick={createProfessional}
                color="primary"
                variant="contained"
                className={classes.submit}
              >
                Registrati
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Container>
  );
};
